// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WkuA","newExpiryDate":"styles_newExpiryDate__3nhO9","footer":"styles_footer__2PRTW"};